var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegAboveTheFoldL(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 80,
    viewBox: "0 0 140 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 0.0195312H6.51163C2.91535 0.0195312 0 2.67266 0 5.94546V74.0936C0 77.3664 2.91535 80.0195 6.51163 80.0195H133.488C137.085 80.0195 140 77.3664 140 74.0936V5.94546C140 2.67266 137.085 0.0195312 133.488 0.0195312Z",
    fill: "#4F4C57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_592_39402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.233 5.94531H45.3257V74.0935H133.233V5.94531Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7444 23.7227H53.4653C52.5662 23.7227 51.8374 24.3859 51.8374 25.2041C51.8374 26.0223 52.5662 26.6856 53.4653 26.6856H69.7444C70.6434 26.6856 71.3723 26.0223 71.3723 25.2041C71.3723 24.3859 70.6434 23.7227 69.7444 23.7227Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.093 29.6484H53.4653C52.5662 29.6484 51.8374 30.3117 51.8374 31.1299C51.8374 31.9481 52.5662 32.6114 53.4653 32.6114H125.093C125.992 32.6114 126.721 31.9481 126.721 31.1299C126.721 30.3117 125.992 29.6484 125.093 29.6484Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2328 38.5371H53.4653C52.5662 38.5371 51.8374 39.2004 51.8374 40.0186C51.8374 40.8368 52.5662 41.5001 53.4653 41.5001H63.2328C64.1318 41.5001 64.8607 40.8368 64.8607 40.0186C64.8607 39.2004 64.1318 38.5371 63.2328 38.5371Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7262 65.2054H67.4787C68.9692 65.2054 69.7454 64.4951 69.7454 63.1381V55.4208C69.7454 54.0637 68.9692 53.3535 67.4787 53.3535H55.7262C54.2425 53.3535 53.4663 54.0574 53.4663 55.4208V63.1381C53.4663 64.4951 54.2425 65.2054 55.7262 65.2054ZM58.8377 59.3968C57.8967 59.3968 57.1206 58.6866 57.1206 57.8177C57.1206 56.9554 57.8967 56.2325 58.8377 56.2325C59.7718 56.2325 60.5412 56.9554 60.5412 57.8177C60.5412 58.6866 59.7718 59.3968 58.8377 59.3968ZM55.8361 63.9434C55.211 63.9434 54.8332 63.5947 54.8332 63.0113V62.504L56.7702 60.944C57.0724 60.6967 57.3747 60.5763 57.6975 60.5763C58.0272 60.5763 58.3706 60.7031 58.6728 60.9503L59.9711 62.0347L63.22 59.3714C63.5497 59.0987 63.9206 58.9719 64.3053 58.9719C64.6762 58.9719 65.0678 59.1051 65.3836 59.384L68.3716 61.9333V63.0176C68.3716 63.5947 67.9801 63.9434 67.3756 63.9434H55.8361Z",
    fill: "#908CA0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3257 5.94531H6.51172V74.0935H42.3257V5.94531Z",
    fill: "#908CA0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_592_39402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.907,
    height: 68.1481,
    fill: "white",
    transform: "translate(45.3257 5.94531)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegAboveTheFoldL);
export default __webpack_public_path__ + "static/media/icon-reg-above-the-fold-L.a9b05fd242b44ceb9ac5b0ad527f29c1.svg";
export { ForwardRef as ReactComponent };